export default $covenants => {
  const getCovenants = () => $covenants.covenants
  return { getCovenants }
}
